// extracted by mini-css-extract-plugin
export default {"sectionContainer":"wechat_sectionContainer__NzuOs","orgContainer":"wechat_orgContainer__QPwR-","qrCode":"wechat_qrCode__Iwrlm"};